<template>
  <div id="bridgepayDeposit">
    <div class="content_box">
      <div class="inner_max">
        <div class="form_deposit">
          <div class="contact_title">
            <h2>{{ $t('deposit.default.deposit') }}</h2>
            <p></p>
          </div>
          <!-- <h4>{{ $t('deposit.default.channels.creditOrDebit') }}</h4> -->
          <div id="main"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/page/deposit';
import { sensorsTrack } from '@/util/sensorsdata';
import { SENSORS_TRACK } from '@/util/sensorsdata/constant';
import sensorsHandler from '@/util/sensorsdata/handler';
export default {
  name: 'BridgepayDepositPCS',
  mixins: [mixin],
  data() {
    return {};
  },
  computed: {
    bridgePayData() {
      return this.$store.state.payment.bridgePayData;
    },
    orderInfo() {
      return this.$store.state.payment.orderInfo;
    }
  },
  watch: {
    bridgePayData(newValue) {
      this.showBridgerpay(newValue);
    }
  },
  methods: {
    showBridgerpay(data) {
      if (data && Object.keys(data).length > 0) {
        let script = document.createElement('script');
        script.setAttribute('src', data.url);
        script.setAttribute('data-cashier-key', data.key);
        script.setAttribute('data-theme', 'dark');
        script.setAttribute('data-cashier-token', data.token);
        document.getElementById('main').appendChild(script);
        sensorsHandler('DEPOSIT_STEP3_CCBRIDGERPAGE_VIEW', this.orderInfo);
      }
    }
  },
  mounted() {
    sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_DETAIL_PAGE_VIEW);
    this.showBridgerpay(this.bridgePayData);
  },
  beforeDestroy() {
    this.$store.dispatch('payment/actionSetBridgePayData', {});
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/deposit/deposit.scss';
.note {
  margin-bottom: 30px;
  color: $secondary-text;

  /deep/ a {
    color: $link-text;
    text-decoration: underline;
  }
}
</style>
<style lang="scss">
.info_box_img {
  .img1 {
    position: absolute;
    right: 90px !important;
    top: 0;
  }

  .img2 {
    width: 78px;
    height: 58px;
    position: absolute;
    right: 0;
    top: 15px !important;
  }
}
</style>
